<template>
  <div>
    <div class="content-box">
      <!-- Header Action Bar -->
      <div class="sticky-mobile-only mb-3" style="width: fit-content;">
        <router-link class="btn btn-sm btn-dark radius_custom_black pulse-dark py-3 px-4 cursor-pointer" :to="{ name: 'af-activos', params: {} }">
          <i class="fas fa-chevron-left"></i>
          Regresar
        </router-link>
      </div>

      <div class="row element-box white_gradient_bg_light shadow_inset_lg">
        
        <!-- Left Column: Core Info & Media -->
        <div class="col-sm-5 sticky-left-column">
          <div class="element-info">
            <div class="element-info-with-icon">
              <div class="element-info-text">
                <br />
                <div class="element-inner-header w-100 d-flex justify-content-between align-items-center px-0 flex-nowrap">
                  
                  <div class="d-flex align-items-center">
                    <span style="font-size: 25px; color: #000000;" class="font-weight-bold"></span>
                    <div class="badge d-flex align-items-center justify-content-center" style="border-radius: 25px; font-size: 14px; height: 38px; padding: 0 15px;" :class="{
                      'pulse-blue radius_custom_blue': current.estado == 'E',
                      'pulse-green radius_custom_green': current.estado == 'B',
                      'pulse-warning radius_custom_warning': current.estado == 'M',
                      'pulse-red radius_custom_red': current.estado == '9',
                    }">
                      <i class="far fa-circle" style="font-size: 10px; margin-right: 5px;"></i>
                      <span v-if="current.estado == 'E'">Excelente</span>
                      <span v-if="current.estado == 'B'">Buen Estado</span>
                      <span v-if="current.estado == 'M'">Mal Estado</span>
                      <span v-if="current.estado == '9'">De Baja</span>
                    </div>
                  </div>
                  
                  <!-- Acciones Dropdown -->
                  <div class="dropdown show ">
                    <button 
                      class="btn btn-dark dropdown-toggle d-flex align-items-center justify-content-center radius_custom_black" href="#" 
                      role="button" id="dropdownMenuLink"
                      data-toggle="dropdown" aria-haspopup="true" 
                      aria-expanded="false" :disabled="!current.id || !invoices || invoices.length === 0"
                      style="height: 38px; font-size: 14px; padding: 0 15px;"
                    >
                      <i class="fa fa-cogs"></i>&nbsp;&nbsp;Acciones
                    </button>
                    <div class="dropdown-menu dropdown-menu-right shadow" aria-labelledby="dropdownMenuLink">
                      <button class="dropdown-item" data-toggle="modal" data-target=".bd-example-modal-lg">Imprimir <i
                          class="fas fa-print"></i></button>
                      <div class="dropdown-divider" v-if="puedeModificar"></div>
                      <button v-if="puedeModificar" @click="duplicar()" class="dropdown-item" :disabled="current.estado == '9'">
                        Duplicar Transacción <i class="fas fa-copy"></i>
                      </button>
                      <button v-if="puedeModificar" @click="generarBarraGS1()" class="dropdown-item" :disabled="current.estado == '9' || (current.barra_gs1 && current.barra_gs1 !== 'null' && current.barra_gs1 !== 'None')">
                        Generar Barra GS1 <i class="fas fa-barcode"></i>
                      </button>
                      <button @click="abrirHistorialCentrosCosto()" class="dropdown-item" :disabled="!current.id">
                        Historial Centro Costo <i class="fas fa-history"></i>
                      </button>
                      <button v-if="puedeModificar" @click="bajaActivoFijoModal()" class="dropdown-item" :disabled="current.estado == '9'">
                        Dar de Baja <i class="far fa-trash-alt"></i>
                      </button>
                      <button @click="generarReporteJasper()" class="dropdown-item" :disabled="!current.id">
                        Generar Doc. Responsabilidad <i class="fas fa-file-pdf"></i>
                      </button>
                    </div>
                  </div>

                  
                </div>
              </div>
            </div>
          </div>
          <br />
          <!-- Warning block for deactivated state -->
          <div v-if="current.estado == '9'" class="mb-3">
            <label class="font-weight-bold text-danger text-center d-block">Motivo de Baja</label>
            <div class="btn btn-outline-danger py-2 disabled mt-1 w-100 text-center" style="border-radius: 25px;">
              <i class="fas fa-times-circle mr-2"></i>
              {{ current.motivo_baja_obj ? current.motivo_baja_obj : "Desconocido" }}
            </div>
          </div>

          <br />

          <div class="user-profile compact" style="background-color: #00000000 !important; box-shadow: none !important;">
            <div class="up-head-w custom-image-panel image-container" style="position: relative; overflow: hidden; border-radius: 8px; min-height: 250px; cursor: pointer;" 
                 @click="!$event.target.closest('.image-action-menu') && (mostrarImagenCompleta = true)">
              
              <!-- Dropdown Menu -->
              <div v-if="puedeModificar" class="dropdown image-action-menu" style="position: absolute; top: 15px; right: 15px; z-index: 15;">
                <button class="btn btn-sm shadow-sm dropdown-toggle-no-caret action-gear-btn" type="button" id="imageActionsDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="current.estado == '9' || !current.id || !invoices || invoices.length === 0" style="border-radius: 50%; width: 35px; height: 35px; padding: 0; background-color: rgba(255, 255, 255, 0.85); border: none; color: #6c757d; display: flex; align-items: center; justify-content: center; box-shadow: 0px 2px 5px rgba(0,0,0,0.3);">
                  <i class="fas fa-cog gear-icon" style="font-size: 1.1rem;"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-right shadow" aria-labelledby="imageActionsDropdown">
                  <form action="" @submit.prevent>
                    <input type="file" id="file" style="display: none" ref="file" v-if="current.id"
                      v-on:change="handleFileUpload()" accept="image/*" />
                    
                    <button v-if="file == '' && current.id" class="dropdown-item font-weight-bold py-2" type="button" @click="cambiarfoto">
                      <i class="fas fa-camera text-primary mr-2" style="width: 20px; text-align: center;"></i> Cambiar Foto
                    </button>
                    
                    <template v-if="file != ''">
                      <button class="dropdown-item font-weight-bold text-success py-2" type="button" @click="submitFile">
                        <i class="fas fa-cloud-upload-alt mr-2" style="width: 20px; text-align: center;"></i> Subir y Guardar
                      </button>
                      <button class="dropdown-item font-weight-bold text-danger py-2" type="button" @click="cancelarFoto">
                        <i class="fas fa-times mr-2" style="width: 20px; text-align: center;"></i> Cancelar
                      </button>
                    </template>
                  </form>
                </div>
              </div>

              <!-- Content overlay (Name) -->
              <div class="up-main-info content-overlay d-flex justify-content-center text-center w-100">
                <h2 class="up-header text-white mb-0" style="text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.8);">
                  {{ current.nombre || 'Nuevo Activo Fijo' }}
                </h2>
              </div>

              <!-- Main Image or Preview -->
              <img class="decor image-zoom-effect image-container" style="width: 100%; height: 300px; object-fit: cover; display: block; background-color: #f8f9fa;" 
                :src="imagePreview || current.imagen || fallbackSinImagen" 
                @error="$event.target.onerror = null; $event.target.src=fallbackErrorImagen" />
            </div>

            <div class="mt-3">
              <div class="row no-gutters">
                
                <!-- Card Identificador -->
                <div :class="current.barra_gs1 && current.barra_gs1 !== 'null' && current.barra_gs1 !== 'None' && current.barra_gs1 !== '' ? 'col-12 col-sm-4 pr-sm-1 mb-2 mb-sm-0' : 'col-12 col-sm-6 pr-sm-1 mb-2 mb-sm-0'">
                  <div class="py-2 px-3 shadow_inset_sm d-flex flex-column justify-content-center align-items-start position-relative w-100 h-100" 
                       style="background-color: #f8f9fa; border-radius: 15px; min-width: 0; cursor: pointer; transition: background-color 0.2s; min-height: 52px;"
                       @click="copiarTexto(current.identificador, 'Identificador')"
                       title="Haga click para copiar el Identificador">
                    <div class="d-flex align-items-center mb-1 text-muted" style="font-size: 10px; font-weight: 600; letter-spacing: 0.5px;">
                      <i class="fas fa-fingerprint text-primary mr-1" style="font-size: 11px;"></i> IDENTIFICADOR
                    </div>
                    <div class="d-flex align-items-center w-100 justify-content-between">
                      <span class="font-weight-bold text-dark text-truncate" style="font-size: 11px; font-family: monospace;">
                        {{ current.identificador || 'N/A' }}
                      </span>
                      <i class="far fa-copy text-muted ml-1" style="font-size: 10px;"></i>
                    </div>
                  </div>
                </div>

                <!-- Card Barra GS1 -->
                <div class="col-12 col-sm-4 px-sm-1 mb-2 mb-sm-0" v-if="current.barra_gs1 && current.barra_gs1 !== 'null' && current.barra_gs1 !== 'None' && current.barra_gs1 !== ''">
                  <div class="py-2 px-3 shadow_inset_sm d-flex flex-column justify-content-center align-items-start position-relative w-100 h-100"
                       style="background-color: #f8f9fa; border-radius: 15px; min-width: 0; cursor: pointer; transition: background-color 0.2s; min-height: 52px;"
                       @click="copiarTexto(current.barra_gs1, 'Código de Barra GS1')"
                       title="Haga click para copiar el Código de Barra">
                    <div class="d-flex align-items-center mb-1 text-muted" style="font-size: 10px; font-weight: 600; letter-spacing: 0.5px;">
                      <i class="fas fa-barcode text-success mr-1" style="font-size: 11px;"></i> BARRA GS1
                    </div>
                    <div class="d-flex align-items-center w-100 justify-content-between">
                      <span class="font-weight-bold text-dark text-truncate" style="font-size: 11px; font-family: monospace;">
                        {{ current.barra_gs1 }}
                      </span>
                      <i class="far fa-copy text-muted ml-1" style="font-size: 10px;"></i>
                    </div>
                  </div>
                </div>

                <!-- Card Código SAP -->
                <div :class="current.barra_gs1 && current.barra_gs1 !== 'null' && current.barra_gs1 !== 'None' && current.barra_gs1 !== '' ? 'col-12 col-sm-4 pl-sm-1' : 'col-12 col-sm-6 pl-sm-1'">
                  <div class="py-2 px-3 shadow_inset_sm d-flex flex-column justify-content-center align-items-start position-relative w-100 h-100"
                       style="background-color: #f8f9fa; border-radius: 15px; min-width: 0; transition: background-color 0.2s; min-height: 52px;"
                       :style="[
                         current.errors && current.errors.codigo_sap ? { 'border': '1px solid #dc3545', 'background-color': '#fff8f8' } : {},
                         { 'cursor': (!isEditable || hasSavedCodigoSap) ? 'pointer' : 'default' }
                       ]"
                       @click="(!isEditable || hasSavedCodigoSap) && current.codigo_sap ? copiarTexto(current.codigo_sap, 'Código SAP') : null"
                       :title="(!isEditable || hasSavedCodigoSap) && current.codigo_sap ? 'Haga click para copiar el Código SAP' : ''">
                    <div class="d-flex align-items-center mb-1 text-muted" style="font-size: 10px; font-weight: 600; letter-spacing: 0.5px;"
                         :class="{'text-danger': current.errors && current.errors.codigo_sap}">
                      <i class="fas fa-network-wired mr-1" :class="current.errors && current.errors.codigo_sap ? 'text-danger' : 'text-success'" style="font-size: 11px;"></i> CÓDIGO SAP
                    </div>
                    <div class="w-100">
                      <input v-if="isEditable && !hasSavedCodigoSap" 
                             v-model="current.codigo_sap" 
                             class="form-control form-control-sm border-0 bg-transparent p-0 text-dark font-weight-bold" 
                             style="font-size: 11px; font-family: monospace; outline: none !important; box-shadow: none !important; border: none !important; height: 18px;" 
                             placeholder="Escribir..." />
                      <div v-else 
                           class="d-flex align-items-center w-100 justify-content-between">
                        <span class="font-weight-bold text-dark text-truncate" style="font-size: 11px; font-family: monospace;">
                          {{ current.codigo_sap || 'N/A' }}
                        </span>
                        <i v-if="current.codigo_sap" class="far fa-copy text-muted ml-1" style="font-size: 10px;"></i>
                      </div>
                    </div>
                  </div>
                  <small v-if="current.errors && current.errors.codigo_sap" class="form-text text-danger ml-2 mt-1" style="font-size: 10px;">
                    {{ Array.isArray(current.errors.codigo_sap) ? current.errors.codigo_sap[0] : current.errors.codigo_sap }}
                  </small>
                </div>

              </div>
            </div>
            <div>
              <br />
              <div class="row">
                <div class="col-12 text-left">
                  <InputProvider 
                    label="Nombre de Activo"
                    placeholder="Nombre" 
                    v-model="current.nombre"
                    type="text"
                    autofocus="autofocus"
                    :disabled="!isEditable"
                    :hasError="!!(current.errors && current.errors.nombre)"
                    :errorMessage="current.errors && current.errors.nombre ? current.errors.nombre[0] : ''"
                  />
                </div>
                
                <div class="col-12 text-left">
                  <SelectProvider
                    label="Tipo Activo"
                    v-model="current.tipo_activo"
                    :options="tiposActivo"
                    optionValue="llave"
                    optionLabel="valor"
                    :disabled="!isEditable"
                    :hasError="!!(current.errors && current.errors.tipo_activo)"
                    :errorMessage="current.errors && current.errors.tipo_activo ? (Array.isArray(current.errors.tipo_activo) ? current.errors.tipo_activo[0] : current.errors.tipo_activo) : ''"
                  />
                </div>
                <div class="col-12 text-left">
                    <TextAreaProvider
                      label="Descripción"
                      placeholder="Descripción"
                      v-model="current.descripcion"
                      rows="5"
                      autofocus="autofocus"
                      :maxLength="256"
                      :disabled="!isEditable"
                      :hasError="!!(current.errors && current.errors.descripcion)"
                      :errorMessage="current.errors && current.errors.descripcion ? (Array.isArray(current.errors.descripcion) ? current.errors.descripcion[0] : current.errors.descripcion) : ''"
                    />
                  </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Column: Tabs with grouped fields -->
        <div class="col-sm-7">
          <div class="element-wrapper">
            <!-- Modal for print/constancia -->
            <div class="modal fade bd-example-modal-lg" id="myLargeModal" tabindex="-1" role="dialog"
              aria-labelledby="myLargeModalLabel" aria-hidden="true">
              <div class="modal-dialog">
                <div class="modal-content"
                  style="background: linear-gradient(to bottom right, #d5d4fc, #b8c0f0); position: relative; overflow: hidden;">
                  <div class="modal-header" style="position: relative;">
                    <h5 class="modal-title" id="exampleModalLongTitle">Impresiones
                      <br>
                      Activos Fijos
                    </h5>
                    <button class="btn btn-danger btn-sm" @click="cerrarImpresion()"
                      style="position: relative; z-index: 2;">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                  <div class="modal-body"
                    style="position: relative; display: flex; flex-direction: column; align-items: center;">
                    <i class="fas fa-print"
                      style="font-size: 350px; position: absolute; right: -30px; top: -10px; transform: translateY(-50%); opacity: 0.1; filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3)); z-index: 1;"></i>

                    <div
                      style="display: flex; justify-content: space-around; align-items: flex-start; width: 100%; margin-top: 20px; position: relative; z-index: 1;">
                      <div style="margin: 10px; text-align: center; flex: 1;">
                        <label style="color: #000;">Barras</label>
                        <div id="impresion_barra" @click="Imprimir(current.id)" class="glow-on-hover"
                          title="Imprimir Barra"
                          style="height: 80px; background-color: #000000; color: white; display: flex; justify-content: center; align-items: center; cursor: pointer; border-radius: 15px;">
                          <i class="fas fa-barcode" style="font-size: 50px;"></i>
                        </div>
                      </div>
                      <div style="margin: 10px; text-align: center; flex: 1;">
                        <label style="color: #000;">Registro</label>
                        <div id="impresion_constancia" @click="imprimirConstancia()" class="glow-on-hover"
                          title="Imprimir Constancia de Registro"
                          style="height: 80px; background-color: #000000; color: white; display: flex; justify-content: center; align-items: center; cursor: pointer; border-radius: 15px;">
                          <i class="fas fa-file-alt" style="font-size: 50px;"></i>
                        </div>
                      </div>
                      <div style="margin: 10px; text-align: center; flex: 1;">
                        <label style="color: #000;">Convenio</label>
                        <div id="impresion_convenio" class="glow-on-hover" title="Imprimir Convenio de Aceptación"
                          style="height: 80px; background-color: #ccc; color: white; display: flex; justify-content: center; align-items: center; cursor: not-allowed; border-radius: 15px;">
                          <i class="fas fa-file-signature" style="font-size: 50px; opacity: 0.5;"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            

            <form @submit.prevent>
              <!-- Sección: Solicitado Por -->
              <div class="mb-4 pt-4">
                <h6 class="font-weight-bold" style="color: #6c757d; border-bottom: 1px solid #dee2e6; padding-bottom: 8px; margin-bottom: 20px; font-size: 14px;">
                  <i class="fas fa-user-check mr-2"></i> Personal Vinculado
                </h6>
                <div class="row mx-0">
                  <div class="col-12 text-left px-0">
                    <DynamicSelectProvider
                      label="Persona Solicitante"
                      v-model="current.solicitado_por"
                      :selected-obj="current.solicitado_por_obj"
                      placeholder="Buscar por DPI o Nombre..."
                      :disabled="!isEditable"
                      :can-modify="isEditable"
                      search-url="cat/lista-precio-cupon/"
                      option-label="nombre"
                      option-sublabel="identificacion"
                      sublabel-prefix="DPI: "
                      option-value="id"
                      :max-length="13"
                      :filter-results="opt => opt.identificacion && opt.identificacion.toString().trim().length <= 13 && (opt.id ? opt.id.toString().trim().length <= 13 : true) && opt.id !== current.solicitado_por && (!current.solicitado_por_obj || opt.identificacion !== current.solicitado_por_obj.identificacion)"
                      @select="val => { current.solicitado_por = val ? val.id : null; current.solicitado_por_obj = val; }"
                      @clear="() => { current.solicitado_por = null; current.solicitado_por_obj = null; }"
                    />
                  </div>
                  
                  <div class="col-12 text-left px-0 mt-3">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <label class="mb-0 font-weight-bold" style="font-size: 13px; color: #495057;">
                        Responsable Actual
                        <span v-if="!current_responsable_id && current.id" class="badge badge-light border text-secondary ml-2 font-weight-normal" style="font-size: 11px;">
                          <i class="fas fa-user-slash mr-1"></i> Sin responsable asignado
                        </span>
                      </label>
                      <div>
                        <button 
                          v-if="responsables && responsables.length > 0" 
                          type="button" 
                          class="btn btn-sm btn-link text-info p-0 font-weight-bold" 
                          style="font-size: 12px; text-decoration: none;"
                          @click="abrirHistorialResponsables"
                        >
                          <i class="fas fa-history mr-1"></i> Ver Historial ({{ responsables.length }})
                        </button>
                      </div>
                    </div>
                    <DynamicSelectProvider
                      :label="null"
                      :value="current_responsable_id"
                      :selected-obj="current_responsable_obj"
                      placeholder="Buscar por DPI o Nombre para asignar..."
                      :disabled="!isEditable"
                      :can-modify="isEditable"
                      search-url="cat/lista-precio-cupon/"
                      option-label="nombre"
                      option-sublabel="identificacion"
                      sublabel-prefix="DPI: "
                      option-value="id"
                      :max-length="13"
                      :filter-results="opt => opt.identificacion && opt.identificacion.toString().trim().length <= 13 && (opt.id ? opt.id.toString().trim().length <= 13 : true) && opt.id !== active_responsable_colaborador_id && (!active_responsable_colaborador_identificacion || opt.identificacion !== active_responsable_colaborador_identificacion)"
                      @select="cambiarResponsableActual"
                      @clear="quitarResponsableActual"
                    >
                      <template #actions>
                        <button 
                          class="dropdown-item d-flex align-items-center py-2" 
                          type="button"
                          @click.stop.prevent="subirArchivoResponsableActual"
                        >
                          <i class="fas fa-file-upload mr-2 text-primary" style="width: 16px;"></i> Subir Archivo PDF
                        </button>
                        <a 
                          v-if="current_responsable_archivo_url"
                          :href="current_responsable_archivo_url"
                          target="_blank"
                          class="dropdown-item d-flex align-items-center py-2 text-info"
                        >
                          <i class="fas fa-file-pdf mr-2" style="width: 16px;"></i> Ver Archivo PDF
                        </a>
                        <div class="dropdown-divider"></div>
                        <button 
                          class="dropdown-item d-flex align-items-center py-2 text-success" 
                          type="button"
                          @click.stop.prevent="asignandoNuevoResponsable = true"
                        >
                          <i class="fas fa-user-plus mr-2" style="width: 16px;"></i> Asignar Nuevo Responsable
                        </button>
                        <button 
                          class="dropdown-item d-flex align-items-center py-2 text-warning" 
                          type="button"
                          @click.stop.prevent="abrirHistorialResponsables"
                        >
                          <i class="fas fa-history mr-2" style="width: 16px;"></i> Ver Historial
                        </button>
                      </template>
                    </DynamicSelectProvider>
                    <div v-if="asignandoNuevoResponsable" class="mt-2 text-right">
                      <button type="button" class="btn btn-sm btn-link text-secondary p-0 font-weight-bold" @click="asignandoNuevoResponsable = false">
                        <i class="fas fa-times mr-1"></i> Cancelar Asignación
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Sección 1: Ubicación & Clasificación -->
              <div class="mb-4">
                <h6 class="font-weight-bold" style="color: #6c757d; border-bottom: 1px solid #dee2e6; padding-bottom: 8px; margin-bottom: 20px; font-size: 14px;">
                  <i class="fas fa-map-marker-alt mr-2"></i> Centro Costo & Clasificación
                </h6>
                <div class="row">
                  <div class="col-6 text-left">
                    <SelectProvider 
                      label="Centro de Costo"
                      placeholder="- Seleccione Centro de Costo -"
                      v-model="current.centro_costo"
                      :options="centros_costo"
                      optionValue="id"
                      :optionLabel="cc => cc.id + ' - ' + cc.nombre"
                      :disabled="!isEditable"
                      :hasError="!!(current.errors && current.errors.centro_costo)"
                      :errorMessage="current.errors && current.errors.centro_costo ? (Array.isArray(current.errors.centro_costo) ? current.errors.centro_costo[0] : current.errors.centro_costo) : ''"
                    />
                  </div>
                  <div class="col-6">
                    <SelectProvider 
                      label="Categoría"
                      placeholder="- Seleccione Categoría -"
                      v-model="current.grupo"
                      :options="grupos"
                      optionValue="id"
                      optionLabel="nombre"
                      :disabled="!isEditable"
                      :hasError="!!(current.errors && current.errors.grupo)"
                      :errorMessage="current.errors && current.errors.grupo ? (Array.isArray(current.errors.grupo) ? current.errors.grupo[0] : current.errors.grupo) : ''"
                    />
                  </div>
                  <!-- <div class="col-6 text-left mt-2">
                    <SelectProvider 
                      label="Área"
                      placeholder="- Seleccione Área -"
                      v-model="current.area"
                      :options="areas"
                      optionValue="id"
                      :optionLabel="d => d.id + ' - ' + d.nombre"
                      :disabled="!isEditable"
                      @change="refreshSubArea(current.area)"
                      :hasError="!!(current.errors && current.errors.area)"
                      :errorMessage="current.errors && current.errors.area ? current.errors.area[0] : ''"
                    />
                  </div>
                  <div class="col-6 text-left mt-2">
                    <SelectProvider 
                      label="Sub área"
                      placeholder="- Seleccione Sub área -"
                      v-model="current.sub_area"
                      :options="subareas"
                      optionValue="id"
                      :optionLabel="d => d.id + ' - ' + d.nombre"
                      :disabled="!isEditable"
                      :hasError="!!(current.errors && current.errors.sub_area)"
                      :errorMessage="current.errors && current.errors.sub_area ? current.errors.sub_area[0] : ''"
                    />
                  </div> -->
                  <div class="col-12" v-if="current.tienda">
                    <TiendaSelectComponent :disabled="!isEditable" :desblock="true" :current="current" />
                  </div>
                </div>
              </div>

              <!-- Sección 2: Detalles Físicos -->
              <div class="mb-4">
                <h6 class="font-weight-bold" style="color: #6c757d; border-bottom: 1px solid #dee2e6; padding-bottom: 8px; margin-bottom: 20px; font-size: 14px;">
                  <i class="fas fa-info-circle mr-2"></i> Detalles Físicos
                </h6>
                <div class="row">
                  <div class="col-6 text-left">
                    <SelectProvider 
                      label="Estado"
                      placeholder="Estado" 
                      v-model="current.estado"
                      :options="[
                        {value: 'B', label: 'BUEN ESTADO'},
                        {value: 'M', label: 'MAL ESTADO'},
                        {value: '9', label: 'DE BAJA', disabled: true}
                      ]"
                      optionValue="value"
                      optionLabel="label"
                      :disabled="!isEditable"
                      :hasError="!!(current.errors && current.errors.estado)"
                      :errorMessage="current.errors && current.errors.estado ? current.errors.estado[0] : ''"
                    />
                  </div>
                  <div class="col-6 text-left">
                    <SelectProvider 
                      label="Color"
                      placeholder="Seleccione Color" 
                      v-model="current.color"
                      :options="[
                        {value: 'black', label: 'Negro'},
                        {value: 'white', label: 'Blanco'},
                        {value: 'silver', label: 'Plateado'},
                        {value: 'gray', label: 'Gris'},
                        {value: 'red', label: 'Rojo'},
                        {value: 'blue', label: 'Azul'},
                        {value: 'green', label: 'Verde'},
                        {value: 'Olive', label: 'Olivo'},
                        {value: 'yellow', label: 'Amarillo'},
                        {value: 'orange', label: 'Anaranjado'},
                        {value: 'brown', label: 'Café'},
                        {value: 'purple', label: 'Morado'},
                        {value: 'MediumPurple', label: 'Violeta'},
                        {value: 'pink', label: 'Rosado'},
                        {value: 'gold', label: 'Dorado'},
                        {value: 'turquoise', label: 'Turquesa'},
                        {value: 'LightSkyBlue', label: 'Celeste'},
                        {value: 'beige', label: 'Beige'},
                        {value: 'navy', label: 'Azul Marino'},
                        {value: 'MediumSpringGreen', label: 'Menta'},
                        {value: 'darkred', label: 'Rojo Oscuro'},
                        {value: 'Aqua', label: 'Aqua'},
                        {value: 'fuchsia', label: 'Fucsia'}
                      ]"
                      optionValue="value"
                      optionLabel="label"
                      :disabled="!isEditable"
                      :selectStyle="{
                        'background-color': current.color,
                        'font-weight': 'bold',
                        'color': (current.color == 'white' ||
                          current.color == 'beige' ||
                          current.color == 'turquoise' ||
                          current.color == 'gold' ||
                          current.color == 'MediumSpringGreen' ||
                          current.color == 'LightSkyBlue' ||
                          current.color == 'pink' ||
                          current.color == 'Aqua' ||
                          current.color == 'yellow' ||
                          current.color == null ||
                          current.color == '') ? 'black' : 'white'
                      }"
                      :hasError="!!(current.errors && current.errors.color)"
                      :errorMessage="current.errors && current.errors.color ? (Array.isArray(current.errors.color) ? current.errors.color[0] : current.errors.color) : ''"
                    />
                  </div>
                  <div class="col-12 col-md-12 col-lg-6 text-left mt-2">
                    <SelectProvider 
                      label="Marca"
                      placeholder="Marcas" 
                      v-model="current.marca"
                      :options="marcas"
                      optionValue="id"
                      :optionLabel="d => d.nombre + ' - ' + d.descripcion"
                      :disabled="!isEditable"
                      :hasError="!!(current.errors && current.errors.marca)"
                      :errorMessage="current.errors && current.errors.marca ? current.errors.marca[0] : ''"
                    />
                  </div>
                  <div class="col-12 col-md-12 col-lg-6 text-left mt-2">
                    <InputProvider 
                      label="Modelo"
                      placeholder="Modelo" 
                      v-model="current.modelo"
                      type="text"
                      :disabled="!isEditable"
                      :hasError="!!(current.errors && current.errors.modelo)"
                      :errorMessage="current.errors && current.errors.modelo ? (Array.isArray(current.errors.modelo) ? current.errors.modelo[0] : current.errors.modelo) : ''"
                    />
                  </div>
                  <div class="col-6 text-left mt-2">
                    <SelectProvider 
                      label="Tipo Vehiculo"
                      placeholder="Tipo Vehiculo" 
                      v-model="current.tipo_vehiculo"
                      :options="[
                        {value: 'PI', label: 'PICKUP'},
                        {value: 'S', label: 'SEDAN'},
                        {value: 'PA', label: 'PANEL'},
                        {value: 'C', label: 'CAMION'},
                        {value: 'M', label: 'MOTOCICLETA'}
                      ]"
                      optionValue="value"
                      optionLabel="label"
                      :disabled="!isEditable"
                      :hasError="!!(current.errors && current.errors.tipo_vehiculo)"
                      :errorMessage="current.errors && current.errors.tipo_vehiculo ? current.tipo_vehiculo : ''"
                    />
                  </div>
                  <div class="col-6 text-left mt-2">
                    <InputProvider 
                      label="Placa o S/N"
                      placeholder="# Placa" 
                      v-model="current.placa"
                      type="text"
                      :disabled="!isEditable"
                      :hasError="!!(current.errors && current.errors.placa)"
                      :errorMessage="current.errors && current.errors.placa ? (Array.isArray(current.errors.placa) ? current.errors.placa[0] : current.errors.placa) : ''"
                    />
                  </div>
                  <div class="col-12 text-left mt-2">
                    <InputProvider 
                      label="Dirección MAC"
                      placeholder="Mac Address" 
                      v-model="current.mac_adress"
                      type="text"
                      :disabled="!isEditable"
                      :hasError="!!(current.errors && current.errors.mac_adress)"
                      :errorMessage="current.errors && current.errors.mac_adress ? (Array.isArray(current.errors.mac_adress) ? current.errors.mac_adress[0] : current.errors.mac_adress) : ''"
                    />
                  </div>
                </div>
              </div>

              <!-- Sección 3: Compra & Vida Útil -->
              <div class="mb-4">
                <h6 class="font-weight-bold" style="color: #6c757d; border-bottom: 1px solid #dee2e6; padding-bottom: 8px; margin-bottom: 20px; font-size: 14px;">
                  <i class="fas fa-calculator mr-2"></i> Compra & Vida Útil
                </h6>
                <div class="row">
                  <div class="col-12 text-left mt-2">
                    <InputProvider 
                      label="Fecha Compra"
                      placeholder="Fecha" 
                      v-model="current.fecha_compra"
                      type="date"
                      :disabled="!isEditable"
                      :hasError="!!(current.errors && current.errors.fecha_compra)"
                      :errorMessage="current.errors && current.errors.fecha_compra ? (Array.isArray(current.errors.fecha_compra) ? current.errors.fecha_compra[0] : current.errors.fecha_compra) : ''"
                    />
                  </div>
                  <div class="col-6 text-left mt-2">
                    <InputProvider 
                      label="Vida Util (Meses)"
                      placeholder="# meses" 
                      v-model="current.vida_util"
                      type="number"
                      :disabled="!isEditable"
                      :hasError="!!(current.errors && current.errors.vida_util)"
                      :errorMessage="current.errors && current.errors.vida_util ? (Array.isArray(current.errors.vida_util) ? current.errors.vida_util[0] : current.errors.vida_util) : ''"
                    />
                  </div>
                  <div class="col-6 text-left mt-2">
                    <InputProvider 
                      label="Meses de Garantía"
                      placeholder="# meses" 
                      v-model="current.meses_garantia"
                      type="number"
                      :disabled="!isEditable"
                      :hasError="!!(current.errors && current.errors.meses_garantia)"
                      :errorMessage="current.errors && current.errors.meses_garantia ? (Array.isArray(current.errors.meses_garantia) ? current.errors.meses_garantia[0] : current.errors.meses_garantia) : ''"
                    />
                  </div>

                  <TimeProgressBarProvider
                    :fecha-compra="current.fecha_compra"
                    label1="Vida Util"
                    :valor1="current.vida_util"
                    label2="Garantia"
                    :valor2="current.meses_garantia"
                    sort="DESC"
                  />
                  
                </div>
              </div>



              <!-- Sección 4: Facturas de Producto -->
              <div class="mb-4">
                <h6 class="font-weight-bold" style="color: #6c757d; border-bottom: 1px solid #dee2e6; padding-bottom: 8px; margin-bottom: 20px; font-size: 14px;">
                  <i class="fas fa-file-invoice-dollar mr-2"></i> Facturas de Producto
                </h6>
                
                <!-- Mock Invoice Cards -->
                <div>
                  <div class="col-12 text-left">
                    <InputProvider 
                      label="Precio Compra (Suma de Facturas)"
                      placeholder="Precio de compra" 
                      v-model="current.precio_compra"
                      type="text"
                      inputmode="decimal"
                      min="0"
                      step="0.01"
                      :maxDecimals="2"
                      :formatThousands="true"
                      prefixText="Q"
                      inputClass="text-right"
                      :disabled="true"
                      :hasError="!!(current.errors && current.errors.precio_compra)"
                      :errorMessage="current.errors && current.errors.precio_compra ? (Array.isArray(current.errors.precio_compra) ? current.errors.precio_compra[0] : current.errors.precio_compra) : ''"
                    />
                  </div>
                  <!-- Invoice List -->
                  <div class="d-flex flex-column" style="gap: 10px; width: 100%;">
                    
                    <!-- Item -->
                    <div v-for="item in invoices" :key="item.id" 
                         @click="verDetalleFactura(item)"
                         class="white_gradient_bg_light radius_custom shadow_inset_sm px-3 py-3  position-relative" 
                         style="background-color: #ffffff; border: 1px solid #e9ecef; border-radius: 12px; transition: all 0.2s; box-shadow: 0 1px 3px rgba(0,0,0,0.02); width: 100%; cursor: pointer;">
                      <div class="d-flex align-items-center justify-content-between flex-wrap flex-md-nowrap px-3" style="gap: 8px;">
                        
                        <!-- Left Info: Icon & Invoice & Provider -->
                        <div class="d-flex align-items-center text-truncate" style="min-width: 0; flex: 1;">
                          <i class="fas fa-file-invoice" style="font-size: 2rem; color: #aeaeae;"></i>
                          <div class="text-truncate ml-3">
                            <div class="font-weight-bold text-primary text-truncate" style="font-size: 14px; line-height: 1.2;">
                              <span v-if="item.serie">{{ item.serie }} - </span>{{ item.numero }}
                              <span class="badge badge-light ml-1 font-weight-bold" style="border-radius: 6px; background-color: #f1f3f5; color: #495057; font-size: 9px; padding: 2px 6px;">{{ item.cantidad }} (un)</span>
                            </div>
                            <small class="text-dark font-weight-bold text-truncate d-block" style="font-size: 11px; max-width: 250px;">
                              <span v-if="item.nit_proveedor">{{ item.nit_proveedor }} | </span>{{ item.proveedor }}
                            </small>
                          </div>
                        </div>

                        <!-- Right Info: Date, Price -->
                        <div class="d-flex align-items-center justify-content-end flex-wrap flex-md-nowrap mt-2 mt-md-0" style="gap: 12px;">
                          <!-- Date -->
                          <div class="text-muted text-nowrap" style="font-size: 11px;">
                            <i class="far fa-calendar-alt text-muted mr-1"></i> {{ formatFechaFactura(item.fecha) }}
                          </div>
                          <!-- Price -->
                          <div class="text-right font-weight-bold text-dark font-family-monospace text-nowrap" style="font-family: monospace; font-size: 13px; min-width: 80px;">
                            Q.{{ formatearMiles(item.total) }}
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>

                  <!-- Add Invoice Button -->
                  <div v-if="puedeModificar" class="d-flex justify-content-center mt-3">
                    <button class="btn btn-outline-success shadow_inset_sm d-flex align-items-center justify-content-center px-4 py-3" 
                            style="border-radius: 25px; font-weight: bold; font-size: 13px; cursor: pointer; transition: all 0.2s ease-in-out; min-width: 220px; "
                            type="button" @click="abrirAgregarFactura" :disabled="current.estado == '9'">
                      <i class="fas fa-file-invoice mr-2" style="font-size: 13px;"></i> Agregar Factura
                    </button>
                  </div>

                </div>
              </div>



              <!-- Bottom Save Actions -->
              <!-- <div class="d-flex justify-content-end mt-4">
                <button class="btn btn-success font-weight-bold d-flex align-items-center justify-content-center" 
                        style="border-radius: 25px; height: 42px; padding: 0 30px; font-size: 15px;" 
                        type="button" @click="guardar" :disabled="current.estado == '9'">
                  <i class="fa fa-save mr-2"></i> Guardar Cambios
                </button>
              </div> -->
            </form>
          </div>
        </div>

      <!-- MODAL SELECCIONAR RAZÓN DE BAJA DE ACTIVO FIJO -->
      <div class="modal fade" id="modalBajaActivoFijo" tabindex="-1" 
      role="dialog" aria-labelledby="bajaAFModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="current.nombre">
          <div class="modal-header">
            <h5 class="modal-title" id="bajaAFModalLabel">Baja de Activo Fijo</h5>
            <button type="button" class="btn btn-danger" @click="closeBajaActivoFijoModal()"><i class="fas fa-times"></i></button>
          </div>
          <hr>
          <div class="row mx-4 mt-4">
            <div class="col-6 text-left">
              <h6 class="font-weight-bold">
                {{ current.nombre }}
              </h6>
            </div>
            <div class="col-6 text-right">
                <div class="element-info">
                  <div class="element-info-with-icon">
                    <div class="element-info-text">
                      <div class="element-inner-header">
                        <div class="badge" style="border-radius: 5px" :class="{
                          'badge-blue': current.estado == 'E',
                          'badge-success': current.estado == 'B',
                          'badge-warning': current.estado == 'M',
                          'badge-danger': current.estado == '9',
                        }">
                          <i class="far fa-circle" style="font-size: 8px;"></i> &nbsp;
                          <span v-if="current.estado == 'E'">Excelente</span>
                          <span v-if="current.estado == 'B'">Buen Estado</span>
                          <span v-if="current.estado == 'M'">Mal Estado</span>
                          <span v-if="current.estado == '9'">De Baja</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            <div class="col-12 mt-2 mx-2">
              <p class="mb-4">
                <b>{{ current.marca_obj ? current.marca_obj.nombre : '' }}</b>
              </p>
              <p class="" style="margin-top: -15px">
                <b>Fecha de Compra:</b> &nbsp; 
                {{ 
                  formattedFechaCompra != null && formattedFechaCompra != "Invalid date" ? 
                  formattedFechaCompra : "Desconocida" 
                }}
              </p>
              <p class="" style="margin-top: -15px">
                <b>Fecha de Ingreso:</b> &nbsp;
                {{ 
                  formattedFechaCreacion != null && formattedFechaCreacion != "Invalid date" ? 
                  formattedFechaCreacion : "Desconocida" 
                }}
              </p>
            </div>
            <div class="col-12 mx-2">
              <p class="" style="margin-top: -15px">
                <b>Identificador:</b> &nbsp; 
                {{ current.identificador }}
              </p>
              <p class="" style="margin-top: -15px">
                <b>Barra:</b> &nbsp;
                {{ current.barra_gs1 }}
              </p>
            </div>
          </div>
          <hr>
          <div class="row mx-2 mt-4">
            <div class="col-12 text-center">
              <h5 class="font-weight-bold">
                Razón de la baja del Activo
              </h5>
            </div>
            <div class="my-2 col-12">
              <div class="text-center col-12">
                <div class="row d-flex justify-content-center my-3">
                  <div class="col-12 text-left">
                    <SelectProvider 
                      v-model="selectedRazonBaja"
                      :options="razonBajaActivoFijo"
                      optionValue="llave"
                      optionLabel="valor"
                      placeholder="- Seleccione Razón -"
                      @change="isSelectedRazonBaja = true"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="row mx-0">
            <div class="col-12 mb-3">
              <div class="modal-footer">
                <button :disabled="!isSelectedRazonBaja" @click="bajaActivoFijo(current)" class="btn btn-md btn-danger btn-block">
                  Dar de Baja
                </button>
                <button @click="closeBajaActivoFijoModal()" type="button" class="btn btn-secondary">
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

      <!-- MODAL DETALLE/EDICION DE FACTURA -->
      <ModalProvider
        id="modalDetalleFactura"
        ref="modalDetalleFactura"
        size="md"
      >
        <template #title>
          <i class="fas fa-file-invoice mr-2 text-primary"></i>
          {{ tempInvoice.id ? 'Detalle de Factura' : 'Nueva Factura' }}
        </template>

        <template #body>
          <div class="row">
            <!-- Serie, No. Factura y DocNum -->
            <div class="col-4">
              <InputProvider
                label="Serie"
                placeholder="Ej. FEL"
                v-model="tempInvoice.serie"
                :disabled="!editMode"
              />
            </div>
            <div class="col-4">
              <InputProvider
                label="No. Factura"
                placeholder="Ej. 12345678"
                v-model="tempInvoice.numero"
                :disabled="!editMode"
              />
            </div>
            <div class="col-4">
              <InputProvider
                label="DocNum"
                placeholder="Ej. Doc-998"
                v-model="tempInvoice.docnum"
                :disabled="!editMode"
              />
            </div>

            <!-- NIT y Proveedor -->
            <div class="col-6">
              <InputProvider
                label="NIT Proveedor"
                placeholder="Ej. 12345678"
                v-model="tempInvoice.nit_proveedor"
                :disabled="!editMode"
                @input="limpiarNitProveedor"
              />
            </div>
            <div class="col-6">
              <InputProvider
                label="Proveedor"
                placeholder="Nombre del proveedor"
                v-model="tempInvoice.proveedor"
                :disabled="!editMode"
              />
            </div>

            <!-- Fecha -->
            <div class="col-12">
              <InputProvider
                label="Fecha de Compra"
                type="date"
                v-model="tempInvoice.fecha"
                :disabled="!editMode"
              />
            </div>



            <!-- Cantidad y Precio Unitario -->
            <div class="col-6">
              <InputProvider
                label="Cantidad"
                type="number"
                v-model.number="tempInvoice.cantidad"
                :disabled="!editMode"
                @input="recalcularTotalEdicion"
              />
            </div>
            <div class="col-6">
              <InputProvider
                label="Precio Unitario"
                type="text"
                prefixText="Q."
                v-model="tempInvoice.precio_unitario"
                :maxDecimals="2"
                :formatThousands="true"
                inputClass="text-right"
                :disabled="!editMode"
                @input="recalcularTotalEdicion"
              />
            </div>

            <!-- Total -->
            <div class="col-12 mt-2">
              <div class="p-3 shadow_inset_sm" style="background-color: #f8f9fa; border-radius: 15px; border: 1px solid #e9ecef;">
                <div class="d-flex justify-content-between align-items-center">
                  <span class="font-weight-bold text-secondary" style="font-size: 12px;">TOTAL</span>
                  <span class="font-weight-bold text-dark font-family-monospace" style="font-size: 18px; font-family: monospace;">
                    Q.{{ formatearMiles(tempInvoice.total) }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Lock Warning -->
            <div v-if="!puedeEditarOEliminarFactura(tempInvoice)" class="col-12 mt-2">
              <div class="alert alert-warning p-2 d-flex align-items-center mb-0" style="border-radius: 12px; font-size: 11px;">
                <i class="fas fa-lock mr-2 text-warning" style="font-size: 14px;"></i>
                <span>Factura en estado de solo lectura.</span>
              </div>
            </div>
          </div>
        </template>

        <template #footer>
          <!-- View Mode actions -->
          <template v-if="!editMode">
            <ButtonProvider
              v-if="puedeEditarOEliminarFactura(tempInvoice)"
              label="Editar"
              variant="primary"
              icon="fa-edit"
              @click="activarEdicionFactura"
            />
            <ButtonProvider
              v-if="puedeEditarOEliminarFactura(tempInvoice)"
              label="Eliminar"
              variant="danger"
              icon="fa-trash-alt"
              @click="eliminarFactura"
            />
            <ButtonProvider
              label="Cerrar"
              variant="secondary"
              @click="cerrarDetalleModal"
            />
          </template>

          <!-- Edit/Create Mode actions -->
          <template v-else>
            <ButtonProvider
              label="Guardar"
              variant="success"
              icon="fa-save"
              @click="guardarEdicionFactura"
            />
            <ButtonProvider
              label="Cancelar"
              variant="secondary"
              @click="cancelarEdicionFactura"
            />
          </template>
        </template>
      </ModalProvider>

      <!-- Hidden file input for uploading PDF for active responsible -->
      <input 
        type="file" 
        ref="responsableFileInput" 
        accept=".pdf" 
        style="display: none;" 
        @change="onResponsableFileSelected" 
      />

      <!-- MODAL HISTORIAL DE RESPONSABLES -->
      <ModalProvider
        id="modalHistorialResponsables"
        ref="modalHistorialResponsables"
        size="lg"
      >
        <template #title>
          <i class="fas fa-history mr-2 text-primary"></i>
          Historial de Responsables
        </template>

        <template #body>
          <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
            <table class="table table-striped table-hover align-middle mb-0" style="font-size: 13px; border-collapse: separate; border-spacing: 0;">
              <thead class="bg-light text-secondary font-weight-bold">
                <tr>
                  <th class="py-3 px-3" style="position: sticky; top: 0; background-color: #f8f9fa; z-index: 1; border-bottom: 2px solid #dee2e6;">Colaborador</th>
                  <th class="py-3 px-3" style="position: sticky; top: 0; background-color: #f8f9fa; z-index: 1; border-bottom: 2px solid #dee2e6;">Identificación (DPI)</th>
                  <th class="py-3 px-3 text-center" style="position: sticky; top: 0; background-color: #f8f9fa; z-index: 1; border-bottom: 2px solid #dee2e6;">Periodo</th>
                  <th class="py-3 px-3 text-center" style="position: sticky; top: 0; background-color: #f8f9fa; z-index: 1; border-bottom: 2px solid #dee2e6;">Estatus</th>
                  <th class="py-3 px-3 text-center" style="position: sticky; top: 0; background-color: #f8f9fa; z-index: 1; border-bottom: 2px solid #dee2e6;">Archivo PDF</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!responsables || responsables.length === 0">
                  <td colspan="5" class="text-center py-4 text-muted">
                    <i class="fas fa-user-shield d-block mb-2" style="font-size: 2rem; color: #ced4da;"></i>
                    No hay registros de responsables para este activo.
                  </td>
                </tr>
                <tr v-for="item in responsables" :key="item.id">
                  <td class="py-3 px-3 font-weight-bold text-dark">
                    {{ item.responsable_obj ? item.responsable_obj.nombre : 'N/A' }}
                  </td>
                  <td class="py-3 px-3">
                    {{ item.responsable_obj ? item.responsable_obj.identificacion : 'N/A' }}
                  </td>
                  <td class="py-3 px-3 text-center text-nowrap">
                    {{ formatFechaFactura(item.fecha_inicio) || '...' }} al {{ formatFechaFactura(item.fecha_fin) || 'Presente' }}
                  </td>
                  <td class="py-3 px-3 text-center">
                    <span 
                      class="badge font-weight-bold" 
                      :class="item.estatus === 1 ? 'badge-success' : 'badge-secondary'"
                      style="border-radius: 6px; font-size: 11px; padding: 4px 8px;"
                    >
                      {{ item.estatus === 1 ? 'Activo' : 'Inactivo' }}
                    </span>
                  </td>
                  <td class="py-3 px-3 text-center">
                    <a 
                      v-if="item.archivo_url" 
                      :href="item.archivo_url" 
                      target="_blank" 
                      class="btn btn-sm btn-info font-weight-bold d-inline-flex align-items-center"
                      style="border-radius: 20px; padding: 4px 12px;"
                    >
                      <i class="fas fa-file-pdf mr-1"></i> Ver Archivo
                    </a>
                    <button 
                      v-else 
                      disabled 
                      class="btn btn-sm btn-secondary font-weight-bold d-inline-flex align-items-center"
                      style="border-radius: 20px; padding: 4px 12px; opacity: 0.5; cursor: not-allowed;"
                    >
                      <i class="fas fa-file-pdf mr-1"></i> Sin Archivo
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>

        <template #footer>
          <ButtonProvider
            label="Cerrar"
            variant="secondary"
            style="border-radius: 25px; height: 38px;"
            @click="cerrarHistorialResponsables"
          />
        </template>
      </ModalProvider>

      <!-- MODAL HISTORIAL DE CENTROS DE COSTO -->
      <ModalProvider
        id="modalHistorialCentrosCosto"
        ref="modalHistorialCentrosCosto"
        size="lg"
      >
        <template #title>
          <i class="fas fa-history mr-2 text-primary"></i>
          Historial de Cambios de Centro de Costo
        </template>

        <template #body>
          <div style="max-height: 400px; overflow-y: auto; padding: 15px;">
            <div v-if="!centrosCostoHistorial || centrosCostoHistorial.length === 0" class="text-center py-5 text-muted bg-white border rounded">
              <i class="fas fa-map-marked-alt d-block mb-3" style="font-size: 3rem; color: #ced4da;"></i>
              <span class="font-weight-bold">No hay registros de cambios de centro de costo para este activo.</span>
            </div>
            
            <div v-else>
              <div v-for="(item, index) in centrosCostoHistorial" :key="item.id" class="card mb-3 shadow_inset_sm border" style="border-radius: 12px; overflow: hidden;">
                <!-- Header for latest movement -->
                <div v-if="index === 0" class="bg-success text-white py-1 px-3 d-flex align-items-center" style="font-size: 10px; font-weight: bold; letter-spacing: 0.5px;">
                  <i class="fas fa-check-circle mr-1"></i> ÚLTIMO MOVIMIENTO (ACTUAL)
                </div>
                <div class="card-body p-3 bg-white">
                  <div class="row align-items-center">
                    <!-- Origin -->
                    <div class="col-5 text-left">
                      <span class="text-uppercase text-muted font-weight-bold d-block mb-1" style="font-size: 10px; letter-spacing: 0.5px;">Centro de Costo Origen</span>
                      <div class="font-weight-bold text-primary" style="font-size: 15px;">
                        {{ item.antiguo_centro_costo_obj ? item.antiguo_centro_costo_obj.id : '---' }}
                      </div>
                      <div class="text-muted text-truncate font-weight-normal" style="font-size: 12px; max-width: 100%;" :title="item.antiguo_centro_costo_obj ? item.antiguo_centro_costo_obj.nombre : 'N/A'">
                        {{ item.antiguo_centro_costo_obj ? item.antiguo_centro_costo_obj.nombre : 'N/A' }}
                      </div>
                    </div>
                    
                    <!-- Arrow -->
                    <div class="col-2 text-center px-0 d-flex flex-column align-items-center justify-content-center">
                      <div style="font-size: 18px; color: #6c757d;">
                        <i class="fas fa-arrow-right"></i>
                      </div>
                    </div>
                    
                    <!-- Destination -->
                    <div class="col-5 text-right">
                      <span class="text-uppercase text-muted font-weight-bold d-block mb-1" style="font-size: 10px; letter-spacing: 0.5px;">Centro de Costo Destino</span>
                      <div class="font-weight-bold text-success" style="font-size: 15px;">
                        {{ item.nuevo_centro_costo_obj ? item.nuevo_centro_costo_obj.id : '---' }}
                      </div>
                      <div class="text-muted text-truncate font-weight-normal" style="font-size: 12px; max-width: 100%;" :title="item.nuevo_centro_costo_obj ? item.nuevo_centro_costo_obj.nombre : 'N/A'">
                        {{ item.nuevo_centro_costo_obj ? item.nuevo_centro_costo_obj.nombre : 'N/A' }}
                      </div>
                    </div>
                  </div>
                  
                  <!-- Separator line -->
                  <div class="my-2" style="border-top: 1px solid #f1f5f9;"></div>
                  
                  <!-- Meta Details -->
                  <div class="row align-items-center text-muted" style="font-size: 11px;">
                    <div class="col-6 text-left">
                      <span class="d-block text-uppercase text-secondary font-weight-bold" style="font-size: 8px; letter-spacing: 0.5px;">Usuario Generador del Movimiento</span>
                      <span class="font-weight-bold text-dark">
                        <i class="fas fa-user mr-1 text-muted"></i>
                        {{ item.usuario_obj ? item.usuario_obj.first_name + ' ' + item.usuario_obj.last_name : 'N/A' }}
                      </span>
                    </div>
                    <div class="col-6 text-right">
                      <span class="d-block text-uppercase text-secondary font-weight-bold" style="font-size: 8px; letter-spacing: 0.5px;">Fecha del Cambio</span>
                      <span class="font-weight-bold text-dark text-nowrap">
                        <i class="far fa-calendar-alt mr-1 text-muted"></i>
                        {{ formatFechaHora(item.fecha_cambio) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template #footer>
          <ButtonProvider
            label="Cerrar"
            variant="secondary"
            style="border-radius: 25px; height: 38px;"
            @click="cerrarHistorialCentrosCosto"
          />
        </template>
      </ModalProvider>

      <!-- OVERLAY VER IMAGEN COMPLETA (Puro Vue/CSS) -->
      <div v-if="mostrarImagenCompleta" class="fullscreen-image-overlay" @click="mostrarImagenCompleta = false">
        <div class="overlay-close-btn">
          <i class="fas fa-times"></i>
        </div>
        <img :src="imagePreview || current.imagen || fallbackSinImagen" class="fullscreen-image" @click.stop />
      </div>

      <!-- BOTON DE GUARDAR FLOTANTE -->
      <div 
        v-if="hasChanges && isEditable"
        class="floating-save-container"
        style="position: fixed; bottom: 15px; right: 20px; z-index: 1000;"
      >
        <button 
          class="btn btn-success shadow-lg font-weight-bold d-flex align-items-center justify-content-center" 
          style="border-radius: 25px; height: 50px; padding: 0 25px; font-size: 15px; box-shadow: 0 4px 15px rgba(40, 167, 69, 0.4);" 
          type="button" 
          @click="guardar"
        >
          <i class="fa fa-save mr-2"></i> Guardar Cambios
        </button>
      </div>

    </div>
  </div>
</div>
</template>

<script>
import _ from "lodash";
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import Api from "@/services/Api";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import { ModalProvider, InputProvider, ButtonProvider, TimeProgressBarProvider, DynamicSelectProvider } from "@/components/atomic";
import SelectProvider from "@/components/atomic/atoms/inputs/SelectProvider.vue";
import TextAreaProvider from "@/components/atomic/atoms/inputs/TextAreaProvider.vue";

export default {
  components: { TiendaSelectComponent, ModalProvider, InputProvider, ButtonProvider, SelectProvider, TextAreaProvider, TimeProgressBarProvider, DynamicSelectProvider },
  data() {
    return {
      isSelectedRazonBaja: false,
      selectedRazonBaja: "",
      razonBajaActivoFijo: [],
      formattedFechaCompra: null,
      formattedFechaCreacion: null,
      lastDigitGS1Barra: null,
      marcas: [],
      areas: [],
      subareas: [],
      centros_costo: [],
      file: "",
      imagePreview: null,
      mostrarImagenCompleta: false,
      invoices: [],
      selectedInvoice: null,
      tempInvoice: {},
      editMode: false,
      responsables: [],
      asignandoNuevoResponsable: false,
      centrosCostoHistorial: [],

      tiposActivo: [],
      fallbackSinImagen: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 400' width='800' height='400'><rect width='800' height='400' fill='%23f3f4f6'/><g transform='translate(360, 130)' stroke='%239ca3af' stroke-width='4' fill='none' stroke-linecap='round' stroke-linejoin='round'><rect x='0' y='0' width='80' height='80' rx='8'/><circle cx='25' cy='25' r='8'/><path d='M4 64 L28 40 L48 60 L60 48 L76 64'/></g><text x='50%' y='270' text-anchor='middle' font-family='sans-serif' font-size='18' font-weight='600' fill='%236b7280'>SIN IMAGEN ASIGNADA</text></svg>",
      fallbackErrorImagen: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 400' width='800' height='400'><rect width='800' height='400' fill='%23fef2f2'/><g transform='translate(360, 130)' stroke='%23f87171' stroke-width='4' fill='none' stroke-linecap='round' stroke-linejoin='round'><rect x='0' y='0' width='80' height='80' rx='8'/><circle cx='25' cy='25' r='8'/><path d='M40 0 L35 30 L45 50 L38 80' stroke='%23ef4444' stroke-width='3'/><path d='M4 64 L28 40 L48 60 L60 48 L76 64' opacity='0.6'/></g><text x='50%' y='270' text-anchor='middle' font-family='sans-serif' font-size='18' font-weight='600' fill='%23ef4444'>IMAGEN NO ENCONTRADA</text></svg>",
      current: {
        nombre: null,
        sub_area: null,
        centro_costo: null,
        fecha_compra: "",
        marca: "",
        precio_compra: 0,
        tipo_vehiculo: "",
        no_fact_compra: "",
        tipo_activo: "NC",
        modelo: "",
        mac_adress: "",
        placa: "",
        estado: "",
        color: "",
        encargado_nombre: "",
        encargado_dpi: "",
        vida_util: null,
        meses_garantia: null,
        solicitado_por: null,
        solicitado_por_obj: null,
        errors: [],
      },
      originalDataJson: null,
      errors: [],
      data: [],
      grupos: [],
    };
  },
  computed: {
    puedeModificar() {
      try {
        const grupos = JSON.parse(localStorage.getItem("grupos") || "[]");
        return grupos.some(g => g.nombre === 'AdminProteccionActivos' || g.nombre === 'Admin');
      } catch (e) {
        return false;
      }
    },
    isEditable() {
      if (this.current.estado === '9') return false;
      if (!this.puedeModificar) return false;
      return true;
    },
    puedeModificarSolicitante() {
      return this.isEditable;
    },
    current_responsable_obj() {
      if (this.asignandoNuevoResponsable) {
        return null;
      }
      if (this.responsables && this.responsables.length > 0) {
        const active = this.responsables.find(r => r.estatus === 1);
        return active ? active.responsable_obj : null;
      }
      return null;
    },
    current_responsable_id() {
      if (this.asignandoNuevoResponsable) {
        return null;
      }
      if (this.responsables && this.responsables.length > 0) {
        const active = this.responsables.find(r => r.estatus === 1);
        return active ? active.responsable : null;
      }
      return null;
    },
    current_responsable_archivo_url() {
      if (this.responsables && this.responsables.length > 0) {
        const active = this.responsables.find(r => r.estatus === 1);
        return active ? active.archivo_url : null;
      }
      return null;
    },
    active_responsable_colaborador_id() {
      if (this.responsables && this.responsables.length > 0) {
        const active = this.responsables.find(r => r.estatus === 1);
        return active ? active.responsable : null;
      }
      return null;
    },
    active_responsable_colaborador_identificacion() {
      if (this.responsables && this.responsables.length > 0) {
        const active = this.responsables.find(r => r.estatus === 1);
        return active && active.responsable_obj ? active.responsable_obj.identificacion : null;
      }
      return null;
    },
    hasSavedCodigoSap() {
      if (!this.originalDataJson) {
        return false;
      }
      try {
        const parsed = JSON.parse(this.originalDataJson);
        const origSap = parsed && parsed.current ? parsed.current.codigo_sap : null;
        return !!(origSap && origSap !== 'null' && origSap !== 'None' && origSap !== '');
      } catch (e) {
        return false;
      }
    },
    hasChanges() {
      if (!this.current) {
        return false;
      }
      if (!this.originalDataJson) {
        return false;
      }
      const currentCopy = { ...this.current };
      delete currentCopy.errors;

      const currentJson = JSON.stringify({
        current: currentCopy,
        invoices: this.invoices,
        responsables: this.responsables,
        file: this.file ? `${this.file.name}-${this.file.size}` : ''
      });
      return currentJson !== this.originalDataJson;
    }
  },

  mounted() {
    let self = this;
    if (!this.$route.params.id && !this.puedeModificar) {
      Notifications.alert.warning("Acceso Restringido", "No tiene permisos para registrar nuevos activos fijos.");
      this.$router.push({ name: "af-activos" });
      return;
    }
    self.obtenerListadoTiposActivo();
    self.obtenerListadoMotivosBajaActivoFijo();
    self.refreshArea();
    self.refreshSubArea();
    self.refreshMarca();
    self.refreshCentroCosto();
    self.refreshGrupos();
    if (this.$route.params.id) {
      self.refreshData();
    } else {
      const currentCopy = { ...self.current };
      delete currentCopy.errors;
      self.originalDataJson = JSON.stringify({
        current: currentCopy,
        invoices: self.invoices,
        responsables: self.responsables,
        file: self.file ? `${self.file.name}-${self.file.size}` : ''
      });
    }
    self.recalcularPrecioCompraTotal();
  },
  methods: {
    formatearMiles(valor) {
      if (valor === null || valor === undefined || isNaN(valor)) {
        return "0.00";
      }
      return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valor);
    },
    copiarTexto(texto, label) {
      if (texto === null || texto === undefined) return;
      const textToCopy = String(texto).trim();
      if (!textToCopy) return;

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(textToCopy).then(() => {
          Notifications.alert.success(label + " Copiado", textToCopy);
        }).catch(() => {
          this.fallbackCopiarTexto(textToCopy, label);
        });
      } else {
        this.fallbackCopiarTexto(textToCopy, label);
      }
    },
    fallbackCopiarTexto(texto, label) {
      const textArea = document.createElement("textarea");
      textArea.value = texto;
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          Notifications.alert.success(label + " Copiado", texto);
        } else {
          Notifications.alert.error("Error", "No se pudo copiar el " + label);
        }
      } catch (err) {
        Notifications.alert.error("Error", "Error al intentar copiar el " + label);
      }
      document.body.removeChild(textArea);
    },
    recalcularPrecioCompraTotal() {
      // 1. Recalcular precio total
      const sum = this.invoices.reduce((acc, inv) => acc + parseFloat(inv.total || 0), 0);
      this.current.precio_compra = sum.toFixed(2);

      // 2. Asignar Fecha Compra (la fecha mas antigua de todas las facturas)
      if (this.invoices && this.invoices.length > 0) {
        let earliestDate = null;
        for (const inv of this.invoices) {
          if (inv.fecha) {
            let m = moment(inv.fecha, ["DD/MM/YYYY", "YYYY-MM-DD", "YYYY/MM/DD", "DD-MM-YYYY"]);
            if (!m.isValid()) {
              m = moment(new Date(inv.fecha));
            }
            if (m.isValid()) {
              if (!earliestDate || m.isBefore(earliestDate)) {
                earliestDate = m;
              }
            }
          }
        }
        if (earliestDate) {
          this.current.fecha_compra = earliestDate.format("YYYY-MM-DD");
          // Si tenemos formateador de la fecha para la UI
          if (typeof this.formattedFechaCompra !== 'undefined') {
            this.formattedFechaCompra = earliestDate.format("DD/MM/YYYY");
          }
        }
      }
    },

    puedeEditarOEliminarFactura(item) {
      return this.isEditable;
    },
    guardarFacturasLocales(activoId) {
      let self = this;
      if (self.invoices && self.invoices.length > 0) {
        const localInvoices = self.invoices.filter(inv => !inv.activo);
        if (localInvoices.length > 0) {
          const promises = localInvoices.map(inv => {
            const payload = {
              activo: activoId,
              serie: inv.serie || "",
              numero: inv.numero || "",
              docnum: inv.docnum || "",
              nit_proveedor: inv.nit_proveedor || "",
              proveedor: inv.proveedor || "",
              fecha: inv.fecha,
              cantidad: (inv.cantidad !== undefined && inv.cantidad !== null && inv.cantidad !== "") ? inv.cantidad : 1,
              precio_unitario: parseFloat(String(inv.precio_unitario).replace(/,/g, '')) || 0.00,
              total: inv.total || 0.00
            };
            return DynamicService.save("af", "factura", payload);
          });
          return Promise.all(promises);
        }
      }
      return Promise.resolve();
    },
    obtenerListadoTiposActivo() {
      let self = this;
      DynamicService.getActionList(
        "af",
        "activo",
        "lista_tipos_activo"
      ).then((response) => {
        self.tiposActivo = response.data;
      })
      .catch((error) => { });
    },
    verDetalleFactura(item) {
      this.selectedInvoice = item;
      this.tempInvoice = { ...item };
      if (this.tempInvoice.fecha) {
        let m = moment(this.tempInvoice.fecha, ["DD/MM/YYYY", "YYYY-MM-DD", "YYYY/MM/DD", "DD-MM-YYYY"]);
        if (!m.isValid()) {
          m = moment(new Date(this.tempInvoice.fecha));
        }
        if (m.isValid()) {
          this.tempInvoice.fecha = m.format("YYYY-MM-DD");
        }
      }
      this.editMode = false;
      $("#modalDetalleFactura").modal("show");
    },
    cerrarDetalleModal() {
      $("#modalDetalleFactura").modal("hide");
    },
    activarEdicionFactura() {
      this.editMode = true;
    },
    limpiarNitProveedor() {
      if (typeof this.tempInvoice.nit_proveedor === 'string') {
        // Remover cualquier caracter que no sea letra o número (elimina guiones y espacios)
        this.tempInvoice.nit_proveedor = this.tempInvoice.nit_proveedor.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
      }
    },
    recalcularTotalEdicion() {
      if (typeof this.tempInvoice.precio_unitario === 'string') {
        this.tempInvoice.precio_unitario = this.tempInvoice.precio_unitario.replace(/[^0-9.,]/g, '');
      }
      const cantidad = parseFloat(this.tempInvoice.cantidad || 0);
      const precio = parseFloat(String(this.tempInvoice.precio_unitario || 0).replace(/,/g, ''));
      this.tempInvoice.total = cantidad * precio;
    },
    guardarEdicionFactura() {
      let self = this;
      if (!self.tempInvoice.numero || !self.tempInvoice.proveedor || !self.tempInvoice.fecha) {
        Notifications.alert.error("Validación", "Por favor llene los campos requeridos.");
        return;
      }

      self.recalcularTotalEdicion();

      // Check predicted total sum limit
      let otherInvoicesSum = 0;
      self.invoices.forEach(inv => {
        if (inv.id !== self.tempInvoice.id) {
          otherInvoicesSum += parseFloat(inv.total || 0);
        }
      });
      const predictedTotal = otherInvoicesSum + parseFloat(self.tempInvoice.total || 0);
      if (self.current.tipo_activo === 'NC' && predictedTotal > 1000) {
        Notifications.alert.error("Validación", "La suma total de las facturas no puede superar Q.1,000 para activos No Contables.");
        return;
      }

      // Check if we are editing an existing asset or a new one
      if (self.current.id) {
        // Existing asset: save to server directly
        const payload = {
          activo: self.current.id,
          serie: self.tempInvoice.serie || "",
          numero: self.tempInvoice.numero || "",
          docnum: self.tempInvoice.docnum || "",
          nit_proveedor: self.tempInvoice.nit_proveedor || "",
          proveedor: self.tempInvoice.proveedor || "",
          fecha: self.tempInvoice.fecha,
          cantidad: (self.tempInvoice.cantidad !== undefined && self.tempInvoice.cantidad !== null && self.tempInvoice.cantidad !== "") ? self.tempInvoice.cantidad : 1,
          precio_unitario: parseFloat(String(self.tempInvoice.precio_unitario).replace(/,/g, '')) || 0,
          total: self.tempInvoice.total || 0
        };
        // If it's a UUID (string) it means it exists in DB, so send ID to update
        if (self.tempInvoice.id && typeof self.tempInvoice.id === 'string' && self.tempInvoice.id.length > 8) {
          payload.id = self.tempInvoice.id;
        }

        DynamicService.save("af", "factura", payload)
          .then(() => {
            Notifications.alert.success("Guardado", "Factura guardada correctamente.");
            self.editMode = false;
            self.cerrarDetalleModal();
            self.refreshData();
          })
          .catch((err) => {
            if (err.response && err.response.data && err.response.data.detail) {
              Notifications.alert.error("Error", err.response.data.detail);
            } else {
              Notifications.alert.error("Error", "No se pudo guardar la factura.");
            }
          });
      } else {
        // New asset: work on local state
        if (self.tempInvoice.id === null) {
          const maxId = self.invoices.reduce((max, inv) => (inv.id > max ? inv.id : max), 0);
          self.tempInvoice.id = maxId + 1;
          self.tempInvoice.fecha_creacion = new Date().toISOString();
          self.invoices.push({ ...self.tempInvoice });
          Notifications.alert.success("Guardado", "Factura agregada localmente.");
        } else {
          const index = self.invoices.findIndex(inv => inv.id === self.tempInvoice.id);
          if (index !== -1) {
            self.invoices.splice(index, 1, { ...self.tempInvoice });
            Notifications.alert.success("Actualizado", "Factura actualizada localmente.");
          }
        }
        self.recalcularPrecioCompraTotal();
        self.editMode = false;
        self.cerrarDetalleModal();
      }
    },
    cancelarEdicionFactura() {
      if (this.tempInvoice.id === null) {
        $("#modalDetalleFactura").modal("hide");
      } else {
        this.tempInvoice = { ...this.selectedInvoice };
        this.editMode = false;
      }
    },
    eliminarFactura() {
      const self = this;
      Notifications.alert.confirm(
        "Eliminar Factura",
        "¿Está seguro que desea eliminar esta factura de producto?",
        "",
        function () {
          if (self.current.id && self.selectedInvoice.id && typeof self.selectedInvoice.id === 'string') {
            // Existing asset/invoice: delete from DB
            DynamicService.delete("af", "factura", self.selectedInvoice.id)
              .then(() => {
                Notifications.alert.success("Eliminado", "La factura ha sido eliminada.");
                self.cerrarDetalleModal();
                self.refreshData();
              })
              .catch((err) => {
                if (err.response && err.response.data && err.response.data.detail) {
                  Notifications.alert.error("Error", err.response.data.detail);
                } else {
                  Notifications.alert.error("Error", "No se pudo eliminar la factura.");
                }
              });
          } else {
            // New asset: remove from local list
            self.invoices = self.invoices.filter(inv => inv.id !== self.tempInvoice.id);
            self.recalcularPrecioCompraTotal();
            self.cerrarDetalleModal();
            Notifications.alert.success("Eliminado", "La factura ha sido eliminada.");
          }
        }
      );
    },
    abrirHistorialResponsables() {
      $("#modalHistorialResponsables").modal("show");
    },
    cerrarHistorialResponsables() {
      $("#modalHistorialResponsables").modal("hide");
    },
    abrirHistorialCentrosCosto() {
      $("#modalHistorialCentrosCosto").modal("show");
    },
    cerrarHistorialCentrosCosto() {
      $("#modalHistorialCentrosCosto").modal("hide");
    },
    cambiarResponsableActual(selectedColaborador) {
      if (!selectedColaborador) return;
      const self = this;
      if (!self.current.id) {
        Notifications.alert.warning("Validación", "Debe guardar el activo fijo antes de asignarle un responsable.");
        return;
      }

      const todayStr = moment().format("YYYY-MM-DD");
      const activePrev = (self.responsables || []).find(r => r.estatus == 1 || r.estatus === 1 || r.estatus === '1');

      const saveNewResponsable = () => {
        const payload = {
          activo: self.current.id,
          responsable: selectedColaborador.id,
          fecha_inicio: todayStr,
          fecha_fin: null,
          estatus: 1,
          archivo_url: null
        };
        return DynamicService.save("af", "responsable", payload)
          .then(() => {
            Notifications.alert.success("Responsabilidad", "Responsable asignado correctamente.");
            self.asignandoNuevoResponsable = false;
            self.refreshData();
          })
          .catch((err) => {
            if (err.response && err.response.data && err.response.data.detail) {
              Notifications.alert.error("Error", err.response.data.detail);
            } else {
              Notifications.alert.error("Error", "No se pudo asignar el nuevo responsable.");
            }
          });
      };

      if (activePrev) {
        // Deactivate previous active responsible automatically
        const prevRespId = (activePrev.responsable && typeof activePrev.responsable === 'object')
          ? activePrev.responsable.id
          : (activePrev.responsable || (activePrev.responsable_obj ? activePrev.responsable_obj.id : null));

        const updatePayload = {
          id: activePrev.id,
          activo: self.current.id,
          responsable: prevRespId,
          fecha_inicio: activePrev.fecha_inicio,
          fecha_fin: todayStr,
          estatus: 0,
          archivo_url: activePrev.archivo_url || null
        };
        DynamicService.save("af", "responsable", updatePayload)
          .then(() => {
            saveNewResponsable();
          })
          .catch((err) => {
            console.error("Error deactivating previous responsible:", err);
            if (err.response && err.response.data && err.response.data.detail) {
              Notifications.alert.error("Error", "No se pudo desactivar el responsable anterior: " + err.response.data.detail);
            } else {
              Notifications.alert.error("Error", "No se pudo desactivar el responsable anterior.");
            }
          });
      } else {
        saveNewResponsable();
      }
    },
    quitarResponsableActual() {
      const self = this;
      console.log("--> [AF] Ejecutando quitarResponsableActual...", {
        current: self.current,
        responsables: self.responsables,
        current_responsable_id: self.current_responsable_id
      });

      if (!self.current || !self.current.id) {
        self.asignandoNuevoResponsable = false;
        self.responsables = [];
        Notifications.toast.info("Responsable", "Se ha removido el responsable seleccionado.");
        return;
      }

      const active = (self.responsables || []).find(r => r.estatus == 1 || r.estatus === 1 || r.estatus === '1');
      if (!active) {
        Notifications.alert.info("Responsable", "El activo no tiene ningún responsable activo actualmente.");
        return;
      }

      const todayStr = moment().format("YYYY-MM-DD");
      const respId = (active.responsable && typeof active.responsable === 'object')
        ? active.responsable.id
        : (active.responsable || (active.responsable_obj ? active.responsable_obj.id : null));

      const updatePayload = {
        id: active.id,
        activo: self.current.id,
        responsable: respId,
        fecha_inicio: active.fecha_inicio,
        fecha_fin: todayStr,
        estatus: 0,
        archivo_url: active.archivo_url || null
      };

      const nombreResp = active.responsable_obj ? active.responsable_obj.nombre : (active.responsable ? `ID ${active.responsable}` : 'este responsable');

      Notifications.alert.confirm(
        "Quitar Responsable",
        `¿Está seguro que desea quitar a ${nombreResp}? El activo quedará sin responsable asignado.`,
        "Sí, quitar",
        function() {
          DynamicService.save("af", "responsable", updatePayload)
            .then(() => {
              Notifications.alert.success("Responsabilidad", "Responsable retirado correctamente. El activo ahora está sin responsable asignado.");
              self.refreshData();
            })
            .catch((err) => {
              console.error("Error al retirar responsable:", err);
              if (err.response && err.response.data) {
                const detail = err.response.data.detail || JSON.stringify(err.response.data);
                Notifications.alert.error("Error", detail);
              } else {
                Notifications.alert.error("Error", "No se pudo retirar el responsable.");
              }
            });
        }
      );
    },
    subirArchivoResponsableActual() {
      this.$refs.responsableFileInput.click();
    },
    onResponsableFileSelected(event) {
      const file = event.target.files[0];
      if (!file) return;

      if (file.type !== "application/pdf") {
        Notifications.alert.error("Validación", "El archivo debe ser de tipo PDF.");
        return;
      }

      const active = this.responsables.find(r => r.estatus === 1);
      if (!active) {
        Notifications.alert.error("Error", "No hay un responsable activo asignado.");
        return;
      }

      const self = this;
      self.$store.commit("set_loading", true);

      const formData = new FormData();
      formData.append("activo", self.current.id);
      formData.append("responsable", active.responsable);
      formData.append("fecha_inicio", active.fecha_inicio);
      formData.append("estatus", active.estatus);
      formData.append("archivo_url", file);

      Api().put(`/af/responsable/${active.id}/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(() => {
        Notifications.alert.success("Archivo subido", "El archivo PDF fue subido correctamente.");
        self.refreshData();
      })
      .catch(err => {
        console.error("Error uploading file:", err);
        if (err.response && err.response.data && err.response.data.detail) {
          Notifications.alert.error("Error", err.response.data.detail);
        } else {
          Notifications.alert.error("Error", "No se pudo subir el archivo PDF.");
        }
      })
      .finally(() => {
        self.$store.commit("set_loading", false);
        event.target.value = "";
      });
    },
    abrirAgregarFactura() {
      if (!this.current.id) {
        Notifications.alert.error("Validación", "No se puede agregar una factura si el activo no se ha guardado primero.");
        return;
      }
      let prevNit = "";
      let prevProv = "";
      if (this.invoices && this.invoices.length > 0) {
        const lastInv = this.invoices[this.invoices.length - 1];
        prevNit = lastInv.nit_proveedor || "";
        prevProv = lastInv.proveedor || "";
      }

      this.tempInvoice = {
        id: null,
        serie: "",
        numero: "",
        docnum: "",
        nit_proveedor: prevNit,
        proveedor: prevProv,
        fecha: moment().format("YYYY-MM-DD"),
        cantidad: 1,
        precio_unitario: 0,
        total: 0
      };
      this.editMode = true;
      $("#modalDetalleFactura").modal("show");
    },
    generarBarraGS1() {
      let self = this;
      Notifications.alert.confirm(
        "Generar Barra GS1",
        "¿Está seguro que desea generar una barra única para este activo?",
        "",
        function () {
          DynamicService.postAction(
            "af",
            "activo",
            self.current.id,
            "generar-barra-gs1"
          ).then((response) => {
            self.current.barra_gs1 = response.data.barra_gs1;
            Notifications.alert.success(
              "Barra generada",
              "Se ha generado y asignado correctamente."
            );
          }).catch(err => {
            Notifications.alert.error("Error", "No se pudo generar la barra GS1");
            console.log(err);
          });
        }
      );
    },
    duplicar() {
      let self = this;
      Notifications.alert.confirm(
        "Duplicar información de activo",
        "¿Esta seguro?",
        "",
        function () {
          DynamicService.getAction(
            "af",
            "activo",
            self.current.id,
            "duplicar_activo"
          ).then((response) => {
            self.$router.push({
              name: "af-activos-editar",
              params: { id: response.data.id },
            });
            self.refreshData(response.data.id);
            Notifications.alert.success(
              "Duplicar activo",
              "Realizado satisfactoriamente, por favor actualizar los datos individuales de cada activo"
            );
          });
        }
      );
    },
    cambiarfoto() {
      if (!this.invoices || this.invoices.length === 0) {
        Notifications.alert.error("Validación", "No se puede agregar una foto si antes no se ha agregado al menos una factura.");
        return;
      }
      this.$refs.file.click();
    },
    cancelarFoto() {
      this.file = "";
      this.imagePreview = null;
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      if (this.file) {
        this.imagePreview = URL.createObjectURL(this.file);
      } else {
        this.imagePreview = null;
      }
    },
    submitFile() {
      let self = this;
      if (!self.current.centro_costo) {
        Notifications.alert.error("Validación", "Debe seleccionar un Centro de Costo para poder generar el Identificador del Activo Fijo.");
        return;
      }
      self.current.newActivo = !self.current.id || !self.invoices || self.invoices.length === 0;
      let precio = parseFloat(self.current.precio_compra) || 0;
      if (self.current.tipo_activo === 'NC') {
        if (self.current.id && (precio < 100 || precio > 1000)) {
          Notifications.alert.error("Validación", "Para activos 'No Contables', el precio de compra (suma de facturas) debe estar entre Q.100 y Q.1,000.");
          return;
        }
      } else {
        if (self.current.id && precio < 1000) {
          Notifications.alert.error("Validación", "Para activos contables, el precio de compra (suma de facturas) debe ser igual o mayor a Q.1,000.");
          return;
        }
      }
      const originalFechaCompra = self.current.fecha_compra;
      if (self.current.fecha_compra) {
        self.current.fecha_compra = moment(self.current.fecha_compra, ["YYYY-MM-DD", "DD/MM/YYYY", "YYYY/MM/DD"]).format(
          "DD/MM/YYYY"
        );
      }
      if (self.current.fecha_compra == null) {
        self.current.fecha_compra = "";
      }
      if (self.current.precio_compra == null) {
        self.current.precio_compra = 0;
      }
      if (self.current.tipo_vehiculo == null) {
        self.current.tipo_vehiculo = "";
      }
      if (self.current.marca == null) {
        self.current.marca = "";
      }
      if (self.current.sub_area == null) {
        self.current.sub_area = "";
      }
      if (self.current.area == null) {
        self.current.area = "";
      }
      if (self.current.motivo_baja == null) {
        delete self.current.motivo_baja;
      }
      if (self.current.tipo_activo === undefined || self.current.tipo_activo === null || self.current.tipo_activo === "") {
        self.$set(self.current, "tipo_activo", "NC");
      }
      DynamicService.saveImage("af", "activo", self.current, self.file)
        .then((res) => {
          self.guardarFacturasLocales(res.data.id).then(() => {
            self.current = res.data;
            if (self.current.tipo_activo === undefined || self.current.tipo_activo === null || self.current.tipo_activo === "") {
              self.$set(self.current, "tipo_activo", "NC");
            }
            self.current.pk = self.current.id;
            Notifications.alert.success("Activo Fijo", "Se ha guardado la Información.");
            self.file = "";
            self.imagePreview = null;
            self.$router.push({
              name: "af-activos-editar",
              params: { id: self.current.id },
            });
            self.refreshData(self.current.id);
          });
        })
        .catch((error) => {
          self.file = "";
          self.current.fecha_compra = originalFechaCompra;
          self.current.errors = Object.assign(self.current.errors || {}, (error.response && error.response.data) ? error.response.data : {});
          self.mostrarErrorRespuesta(error, "Error al guardar el activo fijo.");
        });
    },

    /**
     * Helper para mostrar modales de alerta cuando ocurren errores en la respuesta.
     */
    mostrarErrorRespuesta(error, defaultMsg = "Error al procesar la solicitud.") {
      if (error && error.response && error.response.data) {
        const data = error.response.data;
        if (typeof data === "string") {
          Notifications.alert.error("Error", data);
        } else if (data.detail) {
          Notifications.alert.error("Error", data.detail);
        } else if (typeof data === "object") {
          const messages = Object.keys(data).map(key => {
            const val = data[key];
            const msg = Array.isArray(val) ? val.join(", ") : val;
            if (key === "codigo_sap") return `Código SAP: ${msg}`;
            if (key === "barra_gs1") return `Barra GS1: ${msg}`;
            if (key === "identificador") return `Identificador: ${msg}`;
            if (key === "non_field_errors") return `${msg}`;
            return `${key}: ${msg}`;
          });
          if (messages.length > 0) {
            Notifications.alert.error("Error de Validación", messages.join("\n"));
          } else {
            Notifications.alert.error("Error", defaultMsg);
          }
        } else {
          Notifications.alert.error("Error", defaultMsg);
        }
      } else {
        Notifications.alert.error("Error", defaultMsg);
      }
    },

    /**
     * Método que nos permite guardar la data de un
     * Activo Fijo en BD.
     */
    guardar() {
      let self = this;
      if (!self.current.centro_costo) {
        Notifications.alert.error("Validación", "Debe seleccionar un Centro de Costo para poder generar el Identificador del Activo Fijo.");
        return;
      }
      self.current.newActivo = !self.current.id || !self.invoices || self.invoices.length === 0;
      let precio = parseFloat(self.current.precio_compra) || 0;
      if (self.current.tipo_activo === 'NC') {
        if (self.current.id && (precio < 100 || precio > 1000)) {
          Notifications.alert.error("Validación", "Para activos 'No Contables', el precio de compra (suma de facturas) debe estar entre Q.100 y Q.1,000.");
          return;
        }
      } else {
        if (self.current.id && precio < 1000) {
          Notifications.alert.error("Validación", "Para activos contables, el precio de compra (suma de facturas) debe ser igual o mayor a Q.1,000.");
          return;
        }
      }
      if (
        self.current.fecha_compra &&
        self.current.fecha_compra != null &&
        self.current.fecha_compra != ""
      ) {
        self.current.fecha_compra = moment(self.current.fecha_compra, ["YYYY-MM-DD", "DD/MM/YYYY", "YYYY/MM/DD"]).format(
          "DD/MM/YYYY"
        );
      } else {
        self.current.fecha_compra = null;
      }
      delete self.current.imagen;
      if (self.current.tipo_activo === undefined || self.current.tipo_activo === null || self.current.tipo_activo === "") {
        self.$set(self.current, "tipo_activo", "NC");
      }
      DynamicService.save("af", "activo", self.current)
        .then((res) => {
          self.guardarFacturasLocales(res.data.id).then(() => {
            Notifications.alert.success("Activo Fijo", "Se ha guardado la Información.");
            self.current.errors = [];
            self.$router.push({
              name: "af-activos-editar",
              params: { id: res.data.id },
            });
            self.refreshData(res.data.id);
          });
        })
        .catch((error) => {
          self.current.errors = (error.response && error.response.data) ? error.response.data : {};
          self.mostrarErrorRespuesta(error, "Error al guardar el activo fijo.");
        });
    },
    formatFechaFactura(fecha) {
      if (!fecha) return "";
      let m = moment(fecha, ["YYYY-MM-DD", "DD/MM/YYYY", "YYYY/MM/DD", "DD-MM-YYYY"]);
      if (!m.isValid()) {
        m = moment(new Date(fecha));
      }
      return m.isValid() ? m.format("DD/MM/YYYY") : "";
    },
    formatFechaHora(fecha) {
      if (!fecha) return "";
      let m = moment(fecha);
      if (!m.isValid()) {
        m = moment(new Date(fecha));
      }
      return m.isValid() ? m.format("DD/MM/YYYY hh:mm A") : "";
    },
    
    generarReporteJasper() {
      let self = this;
      if (!self.current.id) {
        Notifications.alert.error("Validación", "Debe guardar el activo fijo antes de generar el reporte.");
        return;
      }
      
      const selectedCc = self.centros_costo.find(cc => cc.id === self.current.centro_costo);
      const centroCostoData = selectedCc ? {
        id: selectedCc.id,
        nombre: selectedCc.nombre || ""
      } : {
        id: self.current.centro_costo || "",
        nombre: ""
      };

      const activoData = {
        ...self.current,
        centro_costo_detalle: centroCostoData,
        facturas: self.invoices || [],
        responsables_historial: self.responsables || [],
        centros_costo_historial: self.centrosCostoHistorial || []
      };

      const responsableData = self.current_responsable_obj ? {
        id: self.current_responsable_obj.id,
        nombre: self.current_responsable_obj.nombre || "",
        identificacion: self.current_responsable_obj.identificacion || "",
        puesto: self.current_responsable_obj.puesto || "",
        departamento: self.current_responsable_obj.departamento || ""
      } : null;

      console.log("=== DATOS PARA REPORTE JASPER ===");
      console.log("Activo Fijo Completo:", activoData);
      console.log("Código SAP:", self.current.codigo_sap || "N/A");
      console.log("Centro Costo:", centroCostoData);
      console.log("Facturas (Invoices):", self.invoices);
      console.log("Responsable Activo:", responsableData);
      console.log("Historial Responsables:", self.responsables);
      console.log("Historial Centros de Costo:", self.centrosCostoHistorial);
      
      let det = self.current.id;
      det = det.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=af/tarjeta_responsabilidad.jrxml&id=${det}`
      );

      Notifications.alert.success("Reporte Responsabilidad", "Generando reporte de responsabilidad de activo fijo...");
    },

    refreshData(id = null) {
      let self = this;
      const assetId = id || this.$route.params.id;
      if (!assetId) return;
      DynamicService.getById("af", "activo", assetId).then((response) => {
        self.current = response.data;
        if (self.current.tipo_activo === undefined || self.current.tipo_activo === null || self.current.tipo_activo === "") {
          self.$set(self.current, "tipo_activo", "NC");
        }
        self.formattedFechaCompra = moment(self.current.fecha_compra).format("DD/MM/YYYY");
        self.formattedFechaCreacion = moment(self.current.fecha_creacion).format("DD/MM/YYYY");
        if (self.current.fecha_compra) {
            self.current.fecha_compra = moment(
            self.current.fecha_compra,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD");
        }
        self.current.pk = self.current.id;
        self.invoices = response.data.facturas || [];
        self.responsables = response.data.responsables || [];
        self.centrosCostoHistorial = response.data.centros_costo_historial || [];
        self.recalcularPrecioCompraTotal();

        const currentCopy = { ...self.current };
        delete currentCopy.errors;
        self.originalDataJson = JSON.stringify({
          current: currentCopy,
          invoices: self.invoices,
          responsables: self.responsables,
          file: self.file ? `${self.file.name}-${self.file.size}` : ''
        });
      });
    },
    refreshMarca() {
      let self = this;
      DynamicService.fetch("af", "marca", {
        quitar_paginacion: true,
      }).then((res) => {
        self.marcas = res.data;
      });
    },
    refreshArea() {
      let self = this;
      DynamicService.fetch("cat", "area", {
        quitar_paginacion: true,
      }).then((res) => {
        self.areas = res.data;
      });
    },
    refreshGrupos() {
      let self = this;
      DynamicService.fetch("af", "grupo", {
        quitar_paginacion: true,
      }).then((res) => {
        self.grupos = res.data;
      });
    },
    refreshCentroCosto() {
      let self = this;
      DynamicService.fetch("cat", "centro-costo", {
        quitar_paginacion: true,
        activa: true,
      }).then((res) => {
        self.centros_costo = res.data;
      });
    },
    refreshSubArea(params) {
      let self = this;
      DynamicService.fetch("cat", "sub-area", {
        quitar_paginacion: true,
        area: params,
      }).then((res) => {
        self.subareas = res.data;
      });
    },
    cerrarImpresion() {
      $('#myLargeModal').modal('hide');
    },
    Imprimir(det) {
      det = det.replace(/-/g, "");
      console.log(det)
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/Barra_activos.jrxml&id=${det}`
      );
    },
    ReImprimir(det) {
      det = det.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/Barra_activos.jrxml&id=${det}`
      );
    },
    imprimirConstancia() {
      let det = this.current.id;
      det = det.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=af/activo_fijo.jrxml&id=${det}`
      )
    },
    imprimirConvenio() {
      let det = this.current.id;
      det = det.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=af/convenio_af.jrxml&id=${det}`
      )
    },

    /**
     * Método que obtiene el listado de los motivos de Baja
     * de Activos Fijos.
     */
     obtenerListadoMotivosBajaActivoFijo() {
      let self = this;
      DynamicService.getActionList(
        "af",
        "activo",
        "lista_motivos_anular_activo_fijo"
      ).then((response) => {
        self.razonBajaActivoFijo = response.data;
        console.log(self.razonBajaActivoFijo);
      })
      .catch((error) => { });
    },

    /**
     * Método que cierra el modal de seleccion
     * de motivo de Baja de Activo Fijo.
     */
    closeBajaActivoFijoModal() {
      let self = this;
      self.selectedRazonBaja = "";
      self.isSelectedRazonBaja = false;
      $("#modalBajaActivoFijo").modal("hide");
    },

    /**
     * Método que nos permite abrir el modal
     * para seleccionar razón de la baja del 
     * Activo Fijo
     */
    bajaActivoFijoModal() {
      $("#modalBajaActivoFijo").modal("show");
    },

    /**
     * Método que nos permite hacer efectiva la baja
     * de un Activo Fijo.
     */
    bajaActivoFijo(item) {
      let self = this;
      console.log("dado de baja: "+self.selectedRazonBaja, item)
      Notifications.alert.confirm(
        "Dar de Baja",
        "Se dará de baja al activo, ¿Desea continuar?",
        "Si, Anular",
        function () {
          DynamicService.postAction(
            "af", 
            "activo", 
            self.current.id, 
            "anular", {
              motivo_baja: self.selectedRazonBaja
            }
          )
            .then((response) => {
              Notifications.alert.success("Activo", "Se dió de baja.");
              self.selectedRazonBaja = "";
              self.isSelectedRazonBaja = false;
              $("#modalBajaActivoFijo").modal("hide");
              self.refreshData()
            })
            .catch((error) => {
              Notifications.alert.error("Anular Transacción", error.response.data.detail);
              self.selectedRazonBaja = "";
              self.isSelectedRazonBaja = false;
              $("#modalBajaActivoFijo").modal("hide");
            });
        }
      )
    }
  },
};
</script>

<style scoped>
.action-gear-btn {
  transition: all 0.5s ease-in-out !important;
}

.action-gear-btn:hover {
  background-color: #ffffff !important;
  color: #333333 !important;
  box-shadow: 0px 4px 8px rgba(0,0,0,0.4) !important;
}

.gear-icon {
  transition: transform 0.5s ease-in-out !important;
  transform-origin: center center;
}

.action-gear-btn:hover .gear-icon {
  transform: rotate(180deg);
}

.image-container {
  cursor: pointer;
}

.custom-image-panel {
  position: relative;
}

.image-zoom-effect {
  transition: transform 0.3s ease;
}

.custom-image-panel:hover .image-zoom-effect {
  transform: scale(1.05);
}

/* CSS de Hover eliminado - ahora se usa el modal para ver la foto */

.content-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px;
  background: linear-gradient(to top, rgba(0,0,0,0.85), transparent);
  z-index: 10;
  pointer-events: none;
}

.content-overlay > * {
  pointer-events: auto;
}

.dropdown-toggle-no-caret::after {
  display: none !important;
}

.fullscreen-image-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: zoom-out;
}

.fullscreen-image {
  max-width: 90%;
  max-height: 90vh;
  border-radius: 8px;
  box-shadow: 0 0 25px rgba(0,0,0,0.8);
  cursor: default;
}

.overlay-close-btn {
  position: absolute;
  top: 25px;
  right: 35px;
  color: white;
  font-size: 2.5rem;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.3s;
}

.overlay-close-btn:hover {
  opacity: 1;
}

/* Custom Radius Colors */
.radius_custom_blue {
  border: 1px solid #007bff !important;
  background-color: #007bff !important;
  color: #fff !important;
  border-radius: 25px !important;
}

.radius_custom_green {
  border: 1px solid #28a745 !important;
  background-color: #28a745 !important;
  color: #fff !important;
  border-radius: 25px !important;
}

.radius_custom_black {
  border: 1px solid #343a40 !important;
  background-color: #343a40 !important;
  color: #fff !important;
  border-radius: 25px !important;
}
.radius_custom_black:hover {
  background-color: #23272b !important;
  border-color: #1d2124 !important;
  color: #fff !important;
}

.radius_custom_warning {
  border: 1px solid #ffc107 !important;
  background-color: #ffc107 !important;
  color: #212529 !important;
  border-radius: 25px !important;
}
.radius_custom_red {
  border: 1px solid #dc3545 !important;
  background-color: #dc3545 !important;
  color: #fff !important;
  border-radius: 25px !important;
}

/* Animaciones Pulse para Badges */
.pulse-blue { animation: pulse-badge-blue 1.5s infinite; }
@keyframes pulse-badge-blue {
  0% { box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.8); }
  70% { box-shadow: 0 0 0 8px rgba(0, 123, 255, 0); }
  100% { box-shadow: 0 0 0 0 rgba(0, 123, 255, 0); }
}

.pulse-green { animation: pulse-badge-green 1.5s infinite; }
@keyframes pulse-badge-green {
  0% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.8); }
  70% { box-shadow: 0 0 0 8px rgba(40, 167, 69, 0); }
  100% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0); }
}

.pulse-warning { animation: pulse-badge-warning 1.5s infinite; }
@keyframes pulse-badge-warning {
  0% { box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.8); }
  70% { box-shadow: 0 0 0 8px rgba(255, 193, 7, 0); }
  100% { box-shadow: 0 0 0 0 rgba(255, 193, 7, 0); }
}

.pulse-red { animation: pulse-badge-red 1.5s infinite; }
@keyframes pulse-badge-red {
  0% { box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.8); }
  70% { box-shadow: 0 0 0 8px rgba(220, 53, 69, 0); }
  100% { box-shadow: 0 0 0 0 rgba(220, 53, 69, 0); }
}

.pulse-dark { animation: pulse-badge-dark 1.5s infinite; }
@keyframes pulse-badge-dark {
  0% { box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.8); }
  70% { box-shadow: 0 0 0 8px rgba(52, 58, 64, 0); }
  100% { box-shadow: 0 0 0 0 rgba(52, 58, 64, 0); }
}

@media (min-width: 576px) {
  .sticky-left-column {
    position: -webkit-sticky;
    position: sticky;
    top: 50px;
    align-self: flex-start;
  }
}

.invoice-row:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0,0,0,0.06) !important;
  background-color: #fafbfc !important;
}

.radius_custom {
  border-radius: 30px !important;
}

.green_gradient_bg_SEC {
  background: linear-gradient(45deg, #24B314 0%, #106606 100%) !important;
  color: #fff !important;
  border-radius: 25px !important;
  border: 0px solid #388e3c00 !important;
}

.floating-save-container {
  animation: fadeInUp 0.3s ease-in-out forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.sticky-mobile-only {
  position: -webkit-sticky;
  position: sticky;
  top: 15px;
  z-index: 1050;
}

@media (min-width: 992px) {
  .sticky-mobile-only {
    position: static !important;
  }
}

</style>
